// Shared file extension constants
export const FILE_EXTENSIONS = {
  IMAGE: ["jpg", "jpeg", "png", "gif", "webp", "bmp"] as string[],
  VIDEO: ["mp4", "webm", "ogg", "mov", "mts", "m4v", "vob", "mkv", "avi"] as string[],
  AUDIO: ["mp3", "wav", "ogg", "aac"] as string[],
  PDF: ["pdf"] as string[],
  // Tabular data files that can be rendered as a browsable table via the csv-data endpoint.
  TABLE: ["csv"] as string[],
  // DOCUMENT also includes 3D scan/model formats; we treat these as downloadable files
  // (preview is typically handled by an external viewer / embed, not by the browser directly).
  DOCUMENT: ["doc", "docx", "txt", "rtf", "glb", "gltf", "usdz", "obj", "stl", "ply"] as string[]
} as const;

// Helper function to check if a file extension is browser-playable
// AVI is intentionally excluded: browsers cannot decode video/x-msvideo natively.
export const isBrowserPlayableVideo = (filename: string): boolean => {
  const extension = filename.split(".").pop()?.toLowerCase() || "";
  const browserPlayableFormats = ["mp4", "webm", "ogg", "mov", "m4v"];
  return browserPlayableFormats.includes(extension);
};
